module.exports = __webpack_public_path__ + "img/team-03.17c5e6ff.jpg";